import { useQuery } from '@tanstack/react-query';
import { clientGetEstateStatusReadOnlyHouseholdSettings, useGraphqlClient } from '../../graphql';
import { estateStatusKeys } from '../queryKeys';

export function useEstateStatusReadOnlyHouseholdSettings(householdID: string | undefined | null) {
  const gqlClient = useGraphqlClient();

  const query = useQuery({
    enabled: !!householdID,
    queryKey: estateStatusKeys.readOnlyHouseholdSettings(householdID),
    queryFn: () => {
      if (!householdID) {
        throw new Error('Household ID is required to load Estate Status.');
      }

      return clientGetEstateStatusReadOnlyHouseholdSettings(gqlClient, { householdID });
    },
  });

  return { estateStatusHouseholdSettings: query.data, estateStatusHouseholdSettingsQuery: query };
}
